// extracted by mini-css-extract-plugin
export default {"row":"OrganizationToTagRow_row__I5GNq","checkbox":"OrganizationToTagRow_checkbox__Tzmx8","nameContainer":"OrganizationToTagRow_nameContainer__LBl0J"};